<template>
  <v-app>
    <v-main>
      <v-app-bar color="primary" dense dark v-if="isLogin">
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

        <v-toolbar-title>App Tasaciones</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn text class="bg-black">
          Home
          <v-icon right>mdi-home</v-icon>
        </v-btn>

        <v-btn text class="bg-black">
          Lista
          <v-icon right>mdi-format-list-bulleted-square</v-icon>
        </v-btn>

        <v-btn text class="bg-black">
          Tasar
          <v-icon right>mdi-pencil-plus</v-icon>
        </v-btn>

        <v-menu left bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="bg-black" v-bind="attrs" v-on="on">
              Perfil
              <v-icon right>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item class="hov pointer">
              <v-list-item-title>Mi perfil</v-list-item-title>
            </v-list-item>
            <v-list-item class="hov pointer">
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  computed: {
    isLogin() {
      if (this.$route.name != "Login") {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.hov:hover {
  background: #e0e0e0;
}
.bg-black:hover {
  background: #e0e0e0;
  color: black;
  transition: all 500ms linear;
}
</style>
